

















import { Component, Vue, Prop } from "vue-property-decorator";
import { FocusedTask } from "@/data/models/Task";

@Component
export default class TaskNoteComponent extends Vue {
  @Prop()
  focusedTask!: FocusedTask;

  @Prop()
  editEnabled!: boolean;

  get showNote(): boolean {
    return this.focusedTask.showNote || !!this.note;
  }

  get note() {
    return this.focusedTask.note ?? null;
  }

  set note(text: string | null) {
    this.$emit("noteChanged", text);
  }
}
